import React, { ReactNode, RefObject } from 'react';
import Button from '../Button';
import searchIcone from '../../../img/icones/rechercher.svg';

type Props = {
  placeholder: string;
  onSearch: (string) => void;
  inputRef?: RefObject<HTMLInputElement>;
  noIcon?: boolean;
};

type State = {
  value:string;
};

class SearchInput extends React.Component<Props, State> {
  state: State = {
    value: '',
  };

  search = (): void => {
    this.props.onSearch(this.state.value);
  };

  handleKeyPress = (e: KeyboardEvent): void => {
    if (e.key === 'Enter') {
      this.search();
    }
  };

  render(): ReactNode {
    return (
      <div className="search-input-group">
        {this.props.noIcon || (
          <img
            className="search-icone"
            src={searchIcone}
            alt="rechercher"
          />
        )}
        <input
          type="text"
          ref={this.props.inputRef}
          className="search-input-field"
          placeholder={this.props.placeholder}
          onChange={(event) => this.setState({ value: event.target.value })}
          onKeyUp={this.handleKeyPress.bind(this)}
        />
        <Button
          i18nKey="actions.SEARCH"
          type="primary"
          buttonType="submit"
          onClick={() => this.props.onSearch(this.state.value)}
        />
      </div>
    );
  }
}

export default SearchInput;
